<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="6">
              <v-select
                :items="sortedSemesters"
                v-model="selectedSemesterId"
                label="Học kỳ"
                dense
                outlined
                item-text="displayName"
                item-value="id"
                :disabled="sortedSemesters.length === 0"
                hide-details
                @change="onSemesterChange"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-btn
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            outlined
            :disabled="!selectedSemesterId"
            @click="applyFilter"
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      selectedSemesterId: null
    }
  },
  computed: {
    ...mapGetters('semester', ['semesters']),
    currentMonth() {
      return new Date().getMonth()
    },
    currentSemesterNumber() {
      return this.currentMonth >= 6 ? 1 : 2
    },
    guessedYearCode() {
      const now = new Date()
      const y = now.getFullYear()
      const code = this.currentMonth >= 6 ? `${y}-${y + 1}` : `${y - 1}-${y}`
      return code
    },
    currentYearCode() {
      if (!Array.isArray(this.semesters) || this.semesters.length === 0) return ''
      const codes = this.semesters.map(s => s.schoolYear && s.schoolYear.code).filter(Boolean)
      if (codes.length === 0) return ''
      if (codes.includes(this.guessedYearCode)) return this.guessedYearCode
      return [...codes].sort((a, b) => b.localeCompare(a))[0]
    },
    sortedSemesters() {
      if (!this.currentYearCode) return []
      return this.semesters
        .filter(s => {
          if (!s || !s.schoolYear || s.schoolYear.code !== this.currentYearCode) return false
          const num = this.getSemesterNumberFromTitle(s.title)
          if (!num) return false
          return Number(num) === this.currentSemesterNumber
        })
        .map(s => ({
          ...s,
          displayName: s.schoolYear ? `${s.title} (${s.schoolYear.name || ''})` : s.title
        }))
        .sort((a, b) => (b.title || '').localeCompare(a.title || ''))
    }
  },
  methods: {
    ...mapActions('semester', ['fetchSemesters']),
    getSemesterNumberFromTitle(title) {
      const t = String(title || '').toLowerCase()
      const m = t.match(/\b([12])\b/) || t.match(/([12])/)
      return m ? Number(m[1]) : null
    },
    onSemesterChange() {
      if (this.selectedSemesterId) this.applyFilter()
    },
    applyFilter() {
      const selected = this.semesters.find(s => String(s.id) === String(this.selectedSemesterId))
      this.$emit('onFilterChanged', selected)
    },
    selectDefaultAndSearch() {
      if (!this.selectedSemesterId && this.sortedSemesters.length) {
        this.selectedSemesterId = this.sortedSemesters[0].id
        this.applyFilter()
      }
    }
  },
  async mounted() {
    await this.fetchSemesters()
    this.selectDefaultAndSearch()
  },
  watch: {
    semesters: {
      handler() {
        this.selectDefaultAndSearch()
      },
      deep: true
    }
  }
}
</script>
